import { memo, useState, useEffect } from 'react';
import { usePlatformSafari } from '@utils/common';
import { Section } from './comp.section.js';
import { jsx } from 'react/jsx-runtime';

const PrintRoot = /*#__PURE__*/memo(function PrintRoot(props) {
  const isSafari = usePlatformSafari();
  const [sectionPagesToPhysicalPagesMapping, setMapping] = useState(new Array(props.input.sections.length).fill(undefined));
  const hasPhysicalContextData = sectionPagesToPhysicalPagesMapping.every(it => typeof it === "number");
  const onPhysicalSectionRenderComplete = (sectionIndex, amountOfPhysicalPagesInSection) => {
    setMapping(prev => {
      const next = [...prev];
      next[sectionIndex] = amountOfPhysicalPagesInSection;
      return next;
    });
  };
  useEffect(() => {
    if (hasPhysicalContextData) {
      //
      // NB: Ensure that all PostloadeImage transitions have finished before
      // triggering the ready callback
      //
      setTimeout(() => {
        props.onReady?.();
      }, 150);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPhysicalContextData]);
  return /*#__PURE__*/jsx("div", {
    "data-target": props.target,
    "data-is-safari": isSafari,
    children: props.input.sections.map((section, index) => /*#__PURE__*/jsx(Section, {
      section: section,
      target: props.target,
      format: props.input.format,
      virtualContext: {
        sectionIndex: index,
        sectionsInDocument: props.input.sections.length,
        startPageIndex: props.input.sections.slice(0, index).reduce((acc, curr) => acc + curr.pages.length, 0),
        pagesInDocument: props.input.sections.reduce((acc, curr) => acc + curr.pages.length, 0)
      },
      physicalContext: hasPhysicalContextData ? {
        sectionIndex: index,
        sectionsInDocument: props.input.sections.length,
        startPageIndex: sectionPagesToPhysicalPagesMapping.slice(0, index).reduce((acc, curr) => acc + curr, 0),
        pagesInDocument: sectionPagesToPhysicalPagesMapping.reduce((acc, curr) => acc + curr, 0)
      } : undefined,
      onPhsyicalPagesRenderedInSection: onPhysicalSectionRenderComplete
    }, index))
  });
});

export { PrintRoot };
//# sourceMappingURL=comp.root.js.map
